"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
exports._CloudFunctionConfiguration = {
    type: "structure",
    required: [],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        Event: {
            shape: {
                type: "string"
            }
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        CloudFunction: {
            shape: {
                type: "string"
            }
        },
        InvocationRole: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_CloudFunctionConfiguration.js.map